<!-- 
    @component
    Use to generally define a layout for the children components.
    // Slots
	/** @slot header - Insert fixed header content.
	 * @slot sidebarLeft - Hidden when empty.
	 * @slot sidebarRight - Hidden when empty.
	 * @slot pageHeader - Insert content that resides above your page content.
	 * @slot pageFooter - Insert content that resides below your page content.
	 * @slot footer - Insert fixed footer content. Not recommended for most layouts.
	 */
 -->

<div id="app-shell">
  <!-- Slot: Header -->
  {#if $$slots.header}
    <header id="shell-header"><slot name="header" /></header>
  {/if}

  <!-- Content Area -->
  <div class="content-area">
    <!-- Slot: Sidebar (left) -->
    {#if $$slots.sidebarLeft}
      <aside id="sidebar-left"><slot name="sidebarLeft" /></aside>
    {/if}

    <!-- Page -->
    <div id="page" on:scroll>
      <!-- Slot: Page Header -->
      {#if $$slots.pageHeader}
        <header id="page-header">
          <slot name="pageHeader">(slot:header)</slot>
        </header>
      {/if}

      <!-- Slot: Page Content (default) -->
      <main id="page-content"><slot /></main>

      <!-- Slot: Page Footer -->
      {#if $$slots.pageFooter}
        <footer id="page-footer">
          <slot name="pageFooter">(slot:footer)</slot>
        </footer>
      {/if}
    </div>

    <!-- Slot: Sidebar (right) -->
    {#if $$slots.sidebarRight}
      <aside id="sidebar-right"><slot name="sidebarRight" /></aside>
    {/if}
  </div>

  <!-- Slot: footer -->
  {#if $$slots.footer}
    <footer id="shell-footer"><slot name="footer" /></footer>
  {/if}
</div>

<style>
  #app-shell {
    /* Breit genug fuer den laengsten Eintrag ("Software Change Analysis");
       die Eintraege schneiden mit Ellipse ab, statt umzubrechen. */
    --app-side-nav-expanded-width: 15.5rem;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: var(--pax-black);
    background-color: var(--pax-smoke);
  }
  #shell-header {
    flex: none;
    z-index: var(--z10);
  }
  .content-area {
    flex: 1 1 auto;
    display: flex;
    overflow: hidden;
    width: 100%;
    height: 100%;
    margin-top: 4rem;
  }
  #sidebar-left,
  #sidebar-right {
    overflow: visible;
    flex: none;
    /* width: auto; */
    z-index: 100;
    position: fixed;
    height:100vh;
    top: 0px;
  }
  #page {
    display: flex;
    overflow-x: hidden;
    position: relative;
    flex-direction: column;
    /* flex: 1 1 0%; */
    width: calc(100vw - var(--app-side-nav-width));
    left: var(--app-side-nav-width);
  }

  #sidebar-left:has(:global(.app-side-nav.expanded)) + #page {
    width: calc(100vw - var(--app-side-nav-expanded-width));
    left: var(--app-side-nav-expanded-width);
  }

  #page-header {
    flex: none;
    position: sticky;
    top: 0;
    z-index: var(--z10);
  }
  #page-content {
    flex: 1 1 auto;
  }
  #page-footer {
    flex: none;
  }
  #shell-footer {
    flex: none;
  }
</style>
